import { optionsFull_save, optionsFull_cancel } from './SettingsFormHeader.locstring.json';
import loc from 'owa-localize';
import { hideFullOptions } from 'owa-options-core';
import { saveOptions, discardOptions } from 'owa-options-orchestration';
import { getStore, getCurrentSubcategoryLoadState } from 'owa-options-store';
import { observer } from 'mobx-react';
import { DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { Spinner, SpinnerSize } from 'office-ui-fabric-react/lib/Spinner';
import {
    OptionSubCategory,
    SubCategoryState,
    isAnyOptionDirty,
    hideSaveDiscardButtons,
    shouldDisableSaveButton,
} from 'owa-options-core';

import * as React from 'react';
import { ControlIcons } from 'owa-control-icons';

const styles = require('./OptionsFull.scss');

export interface SettingsFormHeaderProps {
    selectedSubCategory: OptionSubCategory;
}

@observer
export default class SettingsFormHeader extends React.Component<SettingsFormHeaderProps, {}> {
    render() {
        const store = getStore();
        const { selectedSubCategory } = this.props;
        const isDisabled =
            store.isSaving ||
            getCurrentSubcategoryLoadState() !== SubCategoryState.Loaded ||
            !this.isFormDirty();

        return (
            <div className={styles.settingsHeader}>
                <div className={styles.settingsTitle} role="heading" aria-level={3}>
                    {loc(selectedSubCategory.titleStringKey)}
                </div>
                <div className={styles.settingsHeaderButtons}>
                    {store.isSaving && (
                        <Spinner size={SpinnerSize.large} className={styles.spinner} />
                    )}
                    {!this.hideSaveDiscard() && [
                        <PrimaryButton
                            text={loc(optionsFull_save)}
                            disabled={isDisabled || this.shouldDisableSaveButton()}
                            onClick={saveOptions}
                            key="save"
                        />,
                        <DefaultButton
                            text={loc(optionsFull_cancel)}
                            disabled={isDisabled}
                            onClick={discardOptions}
                            key="discard"
                        />,
                    ]}
                    <IconButton
                        iconProps={{
                            iconName: ControlIcons.Cancel,
                        }}
                        onClick={this.hide}
                    />
                </div>
            </div>
        );
    }

    private hide = () => {
        let { selectedSubCategory } = this.props;

        hideFullOptions(false, selectedSubCategory.key);
    };

    private isFormDirty() {
        let { selectedSubCategory } = this.props;

        return isAnyOptionDirty(selectedSubCategory);
    }

    private hideSaveDiscard() {
        let { selectedSubCategory } = this.props;

        return hideSaveDiscardButtons(selectedSubCategory);
    }

    private shouldDisableSaveButton() {
        let { selectedSubCategory } = this.props;

        return shouldDisableSaveButton(selectedSubCategory);
    }
}
